// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".import-select-method-page__fileimport[data-v-d48de84c]{position:relative;left:9999px}", ""]);
// Exports
module.exports = exports;
